import React from "react";
import { classNames } from "src/helpers/classNames";
import PreloaderIcon from "src/components/Shared/LoadingAnimations/PreloaderIcon";

const Preloader = ({ text = "Loading...", className = "", size = "lg", circleDimension = "14" }) => {
  return (
    <div className={classNames("m-auto flex items-center justify-center gap-x-4 rounded px-8 py-5", className)}>
      <PreloaderIcon
        height={`h-${circleDimension}`}
        width={`w-${circleDimension}`}
      />
      <p className={`m-0 text-${size} pt-1 leading-none text-gray-400`}>{text}</p>
    </div>
  );
};

export default Preloader;
